import { render } from "./CPager.vue?vue&type=template&id=2aa6f68e"
import script from "./CPager.vue?vue&type=script&lang=js"
export * from "./CPager.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__